import script from "./withdrawPWPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./withdrawPWPage.vue?vue&type=script&setup=true&lang=ts"

import "./withdrawPWPage.vue?vue&type=style&index=0&id=844cb992&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-844cb992"]])

export default __exports__